import api from './api';

// Shared manual booking creation — used by the Calendar's Add Booking wizard
// and the Manifest's New booking launcher. One maintenance point.
export async function createManualBooking(data) {
  const finalData = {
    date: data.date,
    startTime: data.startTime,
    duration: data.duration || 120,
    groupSize: data.groupSize ? parseInt(data.groupSize) : undefined,
    assetId: data.assetId || null,
    notes: data.notes || '',
    teamAssignments: data.teamAssignments || [],
    customerName: data.customerName || undefined,
    customerEmail: data.customerEmail || undefined,
    customerPhone: data.customerPhone || undefined,
    pickupLocation: data.pickupLocation || undefined,
    paymentStatus: data.paymentStatus || 'unpaid',
    totalAmount: data.totalAmount || 0,
    timezone: data.timezone || localStorage.getItem('orgTimezone') || 'America/Chicago'
  };

  let createdBooking;

  // If manual card payment, process payment FIRST, then create booking atomically
  if (data.paymentStatus === 'manual_card' && data.cardNumber) {
    if (!window.Stripe) {
      throw new Error('Stripe.js not loaded. Please refresh the page.');
    }

    const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
    const [exp_month, exp_year] = data.cardExpiry.split('/');

    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: 'card',
      card: {
        number: data.cardNumber.replace(/\s/g, ''),
        exp_month: parseInt(exp_month),
        exp_year: parseInt(`20${exp_year}`),
        cvc: data.cardCvc,
      },
      billing_details: {
        name: data.cardName,
      }
    });

    if (error) {
      console.error('Stripe createPaymentMethod error:', error);
      throw new Error(`Card validation failed: ${error.message}`);
    }

    const response = await api.post(`/bookings`, {
      ...finalData,
      paymentMethodId: paymentMethod.id,
      processPayment: true
    });
    createdBooking = response.data;
  } else {
    const response = await api.post(`/bookings`, finalData);
    createdBooking = response.data;
  }

  // Send confirmation email if customer email provided (best-effort)
  if (data.customerEmail && data.customerEmail.trim()) {
    try {
      await api.post('/bookings/send-confirmation-email', { bookingId: createdBooking.id });
    } catch (emailError) {
      console.error('Failed to send email:', emailError);
    }
  }

  return createdBooking;
}
